import { render, staticRenderFns } from "./JobAndCampaignSelector.vue?vue&type=template&id=5c6455fc&scoped=true"
import script from "./JobAndCampaignSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./JobAndCampaignSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobAndCampaignSelector.vue?vue&type=style&index=0&id=5c6455fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6455fc",
  null
  
)

export default component.exports